import { handleError } from './errors.js';

export const onClick = () => {
    const executeCode = (code, event, element) => {
        try {
            new Function(code)();
        } catch (error) {
            handleError('vdx-on-click: error executing code. Check attribute value is valid JavaScript or a global function name.', { module: 'onclick', element, showOnElement: true, error });
        }
    };

    document.querySelectorAll('[vdx-on-click]').forEach((element) => {
        element.addEventListener('click', (event) => {
            const code = element.getAttribute('vdx-on-click');
            if (typeof window[code] === 'function') {
                try {
                    window[code](event, element);
                } catch (error) {
                    handleError('vdx-on-click: error executing code. Check attribute value is valid JavaScript or a global function name.', { module: 'onclick', element, showOnElement: true, error });
                }
            } else {
                executeCode(code, event, element);
            }
        });
    });
};
